<template>
    <div :id="idDivPadre" :style="estilosDiv">
        <button id="btn-recargar-CListaDeImagenes" type="button" class="boton-recargar-informacion float-left" @click="recargarInformacion"><i class="fas fa-sync"></i></button>
         <ul :style="estilosUl" :id="idListaDeImagenes">
            <li v-for="(imagen,index) in listaDeImagenes" :key="index" :id="imagen.llave + 'img'">
                <input type="checkbox" :id="imagen.llave" @click="seleccionImagenObligaciones"/>
                <label :for="imagen.llave">
                    <img v-if="!esParaIconos" :src="imagen.imagen" />
                    <div v-if="esParaIconos" class="pl-4 pr-4 pt-4 pb-4">
                        <i :class="imagen.imagen" style="font-size: 4em;"/>
                    </div>
                </label>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            imagenSeleccionada: null,
            imagenActivaOInactiva: true
        }
    },
    props: {            
      idListaDeImagenes:String,      
      listaDeImagenes:Array,
      estilosExtraUl:String,
      estilosExtraDiv:String,
      esParaIconos: {
          type: Boolean,
          default: false
      },
      idDivPadre: {
        type: String,
        default: 'contenedor-imagenes-predeterminadas-id'
      }
    },
    methods: {
        seleccionImagenObligaciones: function(evento) {
            let imagenActaulId = evento.target.getAttribute('id');
            $('ul li input').each(function(e) {
                $(':checkbox').not(this).prop('checked', false);
            });
            if(imagenActaulId == this.imagenSeleccionada) {
                if(this.imagenActivaOInactiva) {
                     $('#' + imagenActaulId).prop('checked', true);
                     this.imagenActivaOInactiva = false;
                }
                else {
                     $('#' + imagenActaulId).prop('checked', false);
                     this.imagenActivaOInactiva = true;
                }
            } 
            else {
               $('#' + imagenActaulId).prop('checked', true); 
               this.imagenActivaOInactiva = false;
            }
            this.imagenSeleccionada = imagenActaulId;
            let imagenEstaSeleccionada = $('#' + imagenActaulId).is(":checked");
            this.$emit("valorParaElPadre",evento,imagenEstaSeleccionada);
        },
        recargarInformacion: function(evento){
             this.$emit("cargarImagenes",evento);
        },
    },
    computed: {
        estilosUl() {
            return this.estilosExtraUl;
        },
        estilosDiv() {
            return this.estilosExtraDiv;
        }
    },
    created() {
        this.imagenActivaOInactiva = true;
    },
}
</script>
<style scoped>
    #btn-recargar-CListaDeImagenes {
        cursor: pointer;
    }

    ul {
        padding: 0px;
        list-style-type: none;
    }

    li {
        display: inline-block;
    }

    input[type="checkbox"] {
        display: none;
    }

    label {
        border: 2px solid #000;
        padding: 0px;
        display: block;
        position: relative;
        margin: 6px;
        cursor: pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    label::before {
        background-color: black;
        color: black;
        content: " ";
        display: block;
        border-radius: 50%;
        border: 2px solid grey; 
        position: absolute;
        top: -5px;
        left: -5px;
        width: 25px;
        height: 25px;
        text-align: center;
        line-height: 23px;
        transition-duration: 0.4s;
        transform: scale(0);
    }

    label img {
        height: 90px;
        width: 90px;
        transition-duration: 0.2s;
        transform-origin: 50% 50%;
    }

    :checked+label {
        border: 4px solid white;
    }

    :checked+label::before {
        content: "✓";
        color: black;
        background-color: white;
        font-weight: bold;
        transform: scale(1.5);
    }

    :checked+label img {
      /* transform: scale(0.8); 
        transform: scale(0.9);
        box-shadow: 0 0 5px #333;
        z-index: -1; */
    }
    
    .boton-recargar-informacion {
        background-color: #666666;
        border-radius: 4px;
        border: none;
        height:30px ;
        width:30px;
        color: white;
    }

</style>


// WEBPACK FOOTER //
// src/components/SICPO/Comun/CListaDeImagenes.vue